<template>
    <div class="help-trigger">
        <v-icon size="20" class="help-icon">
            mdi-help-circle-outline
        </v-icon>
        <span class="help-label">Tips</span>
        <div class="help-popover">
            <div class="help-popover-arrow" />
            <div class="help-popover-header">
                <v-icon size="18" color="#1976d2">
                    mdi-lightbulb-outline
                </v-icon>
                <span>Editor Tips</span>
            </div>
            <ul class="help-list">
                <li>
                    <kbd>Ctrl</kbd>+<kbd>Z</kbd> to undo, <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>Z</kbd> to redo
                </li>
                <li>
                    <kbd>Ctrl</kbd>+<kbd>Alt</kbd>+<kbd>1-6</kbd> for heading styles
                </li>
                <li>
                    <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>B</kbd> for blockquote
                </li>
                <li>
                    <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>9</kbd> for task list (checkbox)
                </li>
                <li>
                    <kbd>Ctrl</kbd>+<kbd>E</kbd> for inline code,
                    <kbd>Ctrl</kbd>+<kbd>Alt</kbd>+<kbd>C</kbd> for code block
                </li>
                <li>
                    <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>H</kbd> for highlight
                </li>
                <li>
                    <kbd>Shift</kbd>+<kbd>Enter</kbd> for line break (without creating new paragraph)
                </li>
                <li>
                    Select text and click the link button to add a hyperlink
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RichTextAreaHelp'
}
</script>

<style scoped>
.help-trigger {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    border-radius: 0.75rem;
    cursor: default;
    user-select: none;
    color: #777;
    transition: color 0.2s, background-color 0.2s;
    margin-left: auto;
}

.help-trigger:hover {
    color: #1976d2;
    background-color: rgba(25, 118, 210, 0.08);
}

.help-icon {
    color: inherit !important;
    transition: transform 0.2s;
}

.help-trigger:hover .help-icon {
    transform: scale(1.1);
}

.help-label {
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.02em;
}

.help-popover {
    position: absolute;
    top: calc(100% + 0.625rem);
    right: 0;
    width: 20rem;
    background: #fff;
    border-radius: 0.5rem;
    box-shadow:
        0 0.25rem 1.5rem rgba(0, 0, 0, 0.12),
        0 0 0 0.0625rem rgba(0, 0, 0, 0.05);
    padding: 0;
    z-index: 100;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-0.25rem);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
    pointer-events: none;
}

.help-trigger:hover .help-popover {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
}

.help-popover-arrow {
    position: absolute;
    top: -0.375rem;
    right: 1rem;
    width: 0.75rem;
    height: 0.75rem;
    background: #fff;
    transform: rotate(45deg);
    border-top: 0.0625rem solid rgba(0, 0, 0, 0.05);
    border-left: 0.0625rem solid rgba(0, 0, 0, 0.05);
}

.help-popover-header {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.625rem 0.875rem;
    border-bottom: 0.0625rem solid #eee;
    font-size: 0.8125rem;
    font-weight: 600;
    color: #1976d2;
}

.help-list {
    list-style: none;
    padding: 0.5rem 0;
    margin: 0;
}

.help-list li {
    padding: 0.4375rem 0.875rem;
    font-size: 0.8125rem;
    color: #444;
    line-height: 1.5;
    transition: background-color 0.15s;
}

.help-list li:hover {
    background-color: #f8f9fa;
}

.help-list li + li {
    border-top: 0.0625rem solid #f0f0f0;
}

.help-list kbd {
    display: inline-block;
    padding: 0.0625rem 0.3125rem;
    font-size: 0.6875rem;
    font-family: inherit;
    color: #444;
    background: #f4f4f4;
    border: 0.0625rem solid #d0d0d0;
    border-radius: 0.1875rem;
    box-shadow: 0 0.0625rem 0 rgba(0, 0, 0, 0.08);
    line-height: 1.4;
}
</style>
